// extracted by mini-css-extract-plugin
module.exports = {"no_results":"no_results-module__no_results___yhTCH"};